module.exports = __webpack_public_path__ + "files/479a68ec912f41b8a28b1b1f3000b889.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Caligraphic-Regular.woff2
// module id = 953
// module chunks = 60